import type { SiteListEntity } from '@common/types/site.type';

import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';

import { EContentSources } from '@common/enums';

import SitesActions from './sites.actions';
import { SitesHttpService } from './sites.http.service';

@Injectable()
export class SitesCollectionEffect {
    private readonly actions$ = inject(Actions);
    private readonly sitesHttpService = inject(SitesHttpService);

    public readonly loadSitesRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SitesActions.loadCollectionRequest),
            switchMap(() =>
                this.sitesHttpService.getSites([EContentSources.Website, EContentSources.WebEducation]).pipe(
                    map((sites: SiteListEntity[]) => SitesActions.loadCollectionSuccess({ sites })),
                    catchError((error) => [SitesActions.loadCollectionFailure({ error })])
                )
            )
        )
    );
}
